module.exports = __webpack_public_path__ + "media/images/icons/flags/BY-b9d0aac49e66eea6d74f75c6b9193a46.svg";